import type { Active, Over } from '@dnd-kit/core'
import type { WorkIssue } from '@/types/github'

/** Payload attached to every draggable card via useSortable({ data }). */
export type DragData = { issue: WorkIssue }

/** Read the dragged issue off a dnd Active/Over without an unchecked cast. */
export function dragIssue(node: Active | Over | null | undefined): WorkIssue | undefined {
  return (node?.data.current as DragData | undefined)?.issue
}
